import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './sidemap.scss'
const SitemapContent = ({ data }) => {
    return (
        <div className='sitemapcontent'>
            <div className='main-page-heading'>
                <h2><Link to="/">Sentry Insurance home</Link></h2>
            </div>
            <div className='link-section'>
                <Row>
                    {data?.map((item, index) => (
                        <Col md={6} key={index}>
                            <div className='item'>
                                <div className='page-heading'>
                                    <h2><Link to={item.headinglink || '#'}>{item.pageheading}</Link></h2>
                                </div>
                                {item.links && (
                                    <ul className='sitemap-links'>
                                        {item.links.map((linkItem, idx) => (
                                            <li key={idx}>
                                                <Link to={linkItem.link}>{linkItem.linktext}</Link>
                                                {linkItem.sublinks && (
                                                    <ul>
                                                        {linkItem.sublinks.map((subLinkItem, subIdx) => (
                                                            <li key={subIdx}>
                                                                <Link to={subLinkItem.sublink}>{subLinkItem.sublinktext}</Link>
                                                                {subLinkItem.sublinksChild && (
                                                                    <ul>
                                                                        {subLinkItem.sublinksChild.map((sublinksChild, subIdx) => (
                                                                            <li key={subIdx}>
                                                                                <Link to={sublinksChild.sublinkchild}>{sublinksChild.sublinkchildtext}</Link>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                )}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        </div>
    );
};

export default SitemapContent;
